import { useEffect, useState } from "react";
import { fetchPosters } from "../api/postersApi";
import { postersCollection } from "../config/postersConfig";


export const usePosters = () => {
  const [data, setData] = useState(postersCollection);

  useEffect(() => {
    let isMounted = true;

    fetchPosters().then((result) => {
      if (isMounted) setData(result);
    });

    return () => {
      isMounted = false;
    };
  }, []);

  return { data };
};
